// Modules
import React from "react";
// @ts-ignore
import { LocalizationContext } from "react-localize";
import moment from "moment";
import ReservationService from 'Services/reservation.service';
// @ts-ignore
import sessionStorage from "store/storages/sessionStorage";
// Styles
import "./BookingInfoExists.sass";

// Interfaces
import {  RoomType, WaitListReservationDetails, WaitlistRooms } from "Interfaces/AYPResultInterface";
import {RoomModal} from "Interfaces/RoomModalInterface";
import ToolTip from "Generic/ToolTip";

// Utils
import {numberWithCommas} from "Utils";

// Constants
import {InitRoomModal} from "Constants/InitInterfaces";

// Components
import {MvRoomModal} from "Generic/MvModal";
import {MvResortModal} from "Generic/MvModal";
import { ReservationType } from "Interfaces/GetReservations";
import { RequestStatus } from "Constants";
import FilterResults from "Components/PWAS/Components/SearchResults/FilterResults";

type Props = {
  waitlistReservationID: number;
  reservationDetails: WaitListReservationDetails;
  onEditSegmentClick(): void;
  readOnly: boolean;
  visitResortNewTab?: boolean;
  resType?: ReservationType;
  noOfSegmentsInWaitlist: number;
  hideHeader?: boolean;
  waitlistRooms: any;
  totalNoOfSegments?: Number;
  currentSegment?: Number
  // pointAmountMin: number;
};

type State = {
  roomModal: RoomModal;
  resortModal: {
      show: boolean;
      propertyCode: string;
  };
  singleRoomInfo: any;
  roomsRequestStatus: RequestStatus;
  showMoreRoomTypes: boolean;
  itemsToShow: number;
};

const InitState: State = {
  roomModal: Object.assign(InitRoomModal, {}),
  resortModal: {
    show: false,
    propertyCode: '',
  },
  singleRoomInfo: {}, 
  roomsRequestStatus: RequestStatus.NOT_STARTED,
  showMoreRoomTypes: false,
  itemsToShow: 3,
};

class BookingNewSegmentExists extends React.Component<Props, State> {
    reservationService: ReservationService;

    constructor(props: Props) {
    super(props);
    this.reservationService = new ReservationService();
    this.getCheckInDays = this.getCheckInDays.bind(this);
    this.state = Object.assign({}, InitState);

  }

  checkAndExecuteRoomCall = (props: Props) => {
    const roomPoolCode = props.reservationDetails.roomPoolCode;

    if (roomPoolCode && roomPoolCode !== null && this.state.roomsRequestStatus === RequestStatus.NOT_STARTED) {
      const segments = JSON.parse(sessionStorage.read(ReservationService.SEGMENTS));
      const { resortId, roomPoolCode } = props.reservationDetails;
  
      this.fetchFloorPlan({
        segments: segments || ["PTS", "INA", "AP2"],
        resorts : [resortId],
        codeRoomPoolCode: [roomPoolCode]
      });
    }
  };

  componentDidUpdate(nextProps: Props) {
    this.checkAndExecuteRoomCall(nextProps);    
  }

  /**
   * toggle room modal
   */
  toggleRoomModal = (resortId: string, roomPoolCode: string): void => {
    this.fetchFloorPlan({
      segments: ["PTS", "INA", "AP2"],
      resorts : [resortId],
      codeRoomPoolCode: [roomPoolCode]
    });
    if (!this.state.roomModal.show) {
      this.setState({
        roomModal: {
          ...this.state.roomModal,
          show: !this.state.roomModal.show
        },
      } as any);
    } else {
      this.setState({
        roomModal: {
          ...this.state.roomModal,
          show: !this.state.roomModal.show
        },
      } as any);
    }
  }

  toggleResortModal(propertyCode: string) {
    this.setState({
        resortModal: {
            propertyCode,
            show: !this.state.resortModal.show,
        },
    });
  }

  fetchFloorPlan = (roomParams:any) => {
    this.reservationService.searchRoomInfo(roomParams).then(res => {
        this.setState({
            singleRoomInfo: (res as any)[0],
            roomsRequestStatus: RequestStatus.LOADED,
        });
    }).catch(err => {
      this.setState({
        roomsRequestStatus: RequestStatus.ERRORED,
      });
    });
  }

  getCheckInDays() {
    let days = this.props.reservationDetails.checkInSunday ? 'Sun ' : '' + this.props.reservationDetails.checkInMonday? 'Mon ' : '' +
    this.props.reservationDetails.checkInTuesday ? 'Tue ' : '' + this.props.reservationDetails.checkInWednesday ? 'Wed ' : '' +
    this.props.reservationDetails.checkInSunday ? 'Thu ' : '' + this.props.reservationDetails.checkInFriday ? 'Fri ' : '' + 
    this.props.reservationDetails.checkInSaturday ? 'Sat ' : '';
    return (
      <div>
        {days}
      </div>
    )
  }  

  /**
   * 
   * @returns min points and max points for the selected rooms
   */
  getMinMaxPoints() {
    if(this.props.waitlistRooms.length === 0 || !this.props.waitlistRooms) {
      return this.props.reservationDetails.pointsRequired || "";
    }

    if(this.props.waitlistRooms.length === 1) {
      return this.props.waitlistRooms[0].pointAmountMin;
    }

    const waitlistRooms: WaitlistRooms[] = this.props.waitlistRooms;

    const minRoom = waitlistRooms.reduce((prev, curr) => prev.pointAmountMin < curr.pointAmountMin ? prev : curr);
    const maxRoom = waitlistRooms.reduce((prev, curr) => prev.pointAmountMin > curr.pointAmountMin ? prev : curr);

    if(minRoom.pointAmountMin === maxRoom.pointAmountMin) {
      return minRoom.pointAmountMin + maxRoom.pointAmountMin;
    }

    return minRoom.pointAmountMin + " - " + maxRoom.pointAmountMin;
   }

  render() {
    const { localize } = this.context;

    const {
      reservationDetails,
      onEditSegmentClick,
      readOnly,
      resType,
      hideHeader,
    } = this.props;

    const {
      resortName,
      resortId,
      resortImage,
      resortLocation,
      roomType,
      roomPoolCode,
      marshaRateCode,
      checkInRangeStart,
      checkInRangeEnd,
      numOfNights,
      numOfGuests,
      accessibility,
      hearingaccessible,
      checkInSunday,
      checkInMonday,
      checkInTuesday,
      checkInWednesday,
      checkInThursday,
      checkInFriday,
      checkInSaturday
    } = reservationDetails;

    const filteredResult = this.props.waitlistRooms.sort((a: any, b: any) => {
      return a.pointAmountMin - b.pointAmountMin
    })

    const showmore = () => {
      this.setState({
        itemsToShow: this.props.waitlistRooms.length
      })
    }

    const showless = () => {
      this.setState({
        itemsToShow: 3
      })
    }

    return (
      <div className="booking-info-exists">
        {!hideHeader && (<div className="header">
          <h3 className="label">New Segment to add to Waitlist #{this.props.waitlistReservationID}</h3>
        </div>)}
        <div className="detail">
          <div className="resort-container">
            <MvRoomModal
              fetchLoaded={true}
              toggle={() => this.toggleRoomModal("", "")}
              data={{...this.state.roomModal, ...this.state.singleRoomInfo}}
            />
            <MvResortModal
              show={this.state.resortModal.show}
              propertyCode={this.state.resortModal.propertyCode}
              toggle={() => this.setState({ resortModal: { ...this.state.resortModal, show: !this.state.resortModal.show } })}
              visitResortNewTab={this.props.visitResortNewTab}
            />   
            <div className="resort-image">
              <button data-id={resortName} onClick={(e)=>this.toggleResortModal(resortId as string)} className="img-btn">
                <img className="resort-result-image" src={resortImage} alt=""/>
              </button>         
            </div>
            <div className="resort-info">
              <div className="row-container">
                <div className="name-address">
                  <button data-id={resortName.toLowerCase()} onClick={(e)=> this.toggleResortModal(resortId as string)} className="rn-btn">{resortName}</button>                  
                  <p className="resort-address">
                    {resortLocation !== "" ? resortLocation : ""}
                  </p>
                </div>
                <div className="room-type-container">
                  <div className="booking-info-label">
                    {localize("static.content.room-type")}{":"}
                  </div>
                  <span className="room-type mv-print-link">
                    {this.props.waitlistRooms.slice(0, this.state.itemsToShow).map((room: any, i: any) => (
                        <div className="room-description">
                        {this.props.waitlistRooms.length > 0 ? (
                          <div
                            onClick={() => this.toggleRoomModal(resortId || "", room.roomPoolCode)}
                            key={i}
                          >
                            <b>{i === this.props.waitlistRooms.length-1 ? room.roomType.name : room.roomType.name + ","}</b>
                          </div>
                        ) : (
                          <span
                            onClick={() => this.toggleRoomModal(resortId || "", room.roomPoolCode)}
                            key={i}
                          >
                            <b>{"Room Description"}</b>
                          </span>
                        )}
                        </div>
                    ))}
                    {this.props.waitlistRooms.length > 3 && ((this.state.itemsToShow === 3) ? <button className="room-show mv-print-link" onClick={showmore}>View More</button>: <button className="room-show mv-print-link" onClick={showless}>View Less</button>)}
                </span>
                </div>
              </div>
              <div className="row-container">
                <div className="checkin-dates">
                  <span className="booking-info-label">
                    {'Check-In Date'}{": "}
                  </span>
                  <span>
                    {moment(checkInRangeStart).format('DD MMM YYYY')}
                  </span>
                </div>
                {/* <div className="checkin-date">
                  <span className="booking-info-label">
                    {'Check-In Day(s)'}{":"}
                    {this.getCheckInDays()}
                  </span>
                </div> */}
              </div>
              <div className="row-container">
                <div className="nights-guests">
                  <div className="nights">
                    <span className="booking-info-label">
                      {localize("static.content.num-of-nights")}{":"}
                    </span>
                    <span>
                    {numOfNights} {localize(numOfNights > 1 ? "static.content.nights" : "static.content.night")}
                    </span>
                  </div>
                  <div className="guests">
                    <span className="booking-info-label">
                      {localize("static.content.num-of-guests")}{":"}
                    </span>
                    <span>
                    {numOfGuests} {localize(numOfGuests > 1 ? "static.content.guests" : "static.content.guest")}
                    </span>
                  </div>
                </div>
                <div className="accessbility">
                  <span className="booking-info-label">
                    Accessibillity Prefrences{":"}
                  </span>
                  <div className="accessbility-names">
                  {(accessibility && accessibility.length > 0) ? accessibility.map((pref, idx) => {
                    return (
                      <span key={pref.value}>
                        {pref.description}
                        {idx + 1 < accessibility.length ?
                      ', ' : ""}
                      </span>
                    );
                  }) : localize("None")}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="points-needed">
            {
              this.props.noOfSegmentsInWaitlist > 0 &&
              <span className="segment-no">
                <b>Segment:</b>
                {
                  `
                    ${this.props.noOfSegmentsInWaitlist + 1} of 
                    ${this.props.noOfSegmentsInWaitlist + 1}
                  `                
                }
              </span>
            }
            <div className="label-and-points">
              {this.props.currentSegment && this.props.currentSegment > 0 && <div className="booking-info-segment">{`Segment: ${this.props.currentSegment} of ${this.props.totalNoOfSegments}`}</div>}
              <div className="booking-info-label">
                {(resType === ReservationType.CANCELED) ? 
                  localize("static.content.ayp-points-prev-needed")
                  :
                  'Points Needed'
                }
              <ToolTip
                useRefToPosition={false}
                tip={
                  [
                    {
                      label: "",
                      desc: "Need Content"
                    }
                  ]
                }
                id='points-needed'
              >
                <span className="question-icon">{"?"}</span>
              </ToolTip>
            </div>
              <div className="points-container">
                <div>
                  {this.getMinMaxPoints()}
                </div>
              </div>
            </div>
              {/* <div className="edit-segment-btn-container">
                  <button
                    className="edit-segment-btn"
                    onClick={onEditSegmentClick}
                  >
                    {localize("Cancel")}
                  </button>
              </div> */}
        </div>
        </div>
      </div>
    );
  }
}

BookingNewSegmentExists.contextType = LocalizationContext;
export default BookingNewSegmentExists;
